export const OPEN_QUOTATION_MODAL = '/auth/open-quotation-modal'
